/** Iter 695 — "unfinished check-in" poll. Newest live engage session for
 * the signed-in customer (null when nothing to resume). 15 s while the
 * tab is focused + refetch on focus; last known state is kept on network
 * errors so the banner never flashes. */
import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const OPTS = {
  headers: { "X-App-Platform": "nz_classified" },
  params: { platform: "nz_classified" },
};

export function useActiveEngagementSession() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["active-engagement-session"],
    enabled: !!user,
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
    retry: false,
    queryFn: async () =>
      (await sharedApi.get("/classifieds/engagement/my/active-session", OPTS)).data,
  });
}
